import { TFunction } from 'i18next';
import { Flag } from 'shared/assets/icons';
import { DateFormatOptions } from 'shared/types/date-format-options';
import { FilterDateRangeOption, FilterOptionType } from 'shared/types/filter';
import { FilterOptionKeys } from 'shared/types/filter-document';
import { WeekDays } from 'shared/types/week-days';

export type Options = {
  t: TFunction;
  dateFormat: DateFormatOptions;
  weekStartsOn: WeekDays;
};

export const createDeadlineFilter = ({
  t,
  dateFormat,
  weekStartsOn,
}: Options): FilterDateRangeOption => ({
  id: FilterOptionKeys.Deadline,
  label: t('context-menus.filtering.task.filters.date.deadline.title'),
  icon: Flag,
  type: FilterOptionType.DateRange,
  dateFormat,
  weekStartsOn,
  canReset: true,
  isDeadline: true,
});
